// pages/TermsOfService/index.jsx
import React, { useEffect } from "react";
import { Container } from "../../styles/components";
import {
	PolicyWrapper,
	PolicyHeader,
	PolicyContent,
	Section,
	SubSection,
} from "../PrivacyPolicy/styles"; // Reusing the styles
import useNavbar from "../../hooks/useNavbar";

const TermsOfService = () => {
	const { setIsTransparent } = useNavbar();

	useEffect(() => {
		setIsTransparent(false);
		return () => setIsTransparent(true);
	}, [setIsTransparent]);

	return (
		<PolicyWrapper>
			<PolicyHeader>
				<Container>
					<h1>Terms of Service</h1>
					<p>Last updated: January 19, 2025</p>
				</Container>
			</PolicyHeader>

			<Container>
				<PolicyContent>
					<Section>
						<h2>1. Agreement to Terms</h2>
						<p>
							By accessing and using Le Petit Photography's services, you agree
							to be bound by these Terms of Service and all applicable laws and
							regulations.
						</p>
					</Section>

					<Section>
						<h2>2. Photography Services</h2>
						<SubSection>
							<h3>2.1 Session Bookings</h3>
							<ul>
								<li>All sessions must be booked in advance</li>
								<li>Sessions are subject to photographer availability</li>
								<li>Rescheduling must be done at least 48 hours in advance</li>
								<li>No-shows may result in credit deduction</li>
							</ul>
						</SubSection>

						<SubSection>
							<h3>2.2 Subscription Plans</h3>
							<ul>
								<li>
									Subscription plans are billed according to chosen intervals
								</li>
								<li>
									Credits expire at the end of each billing cycle unless
									specified
								</li>
								<li>Plans can be changed at renewal periods</li>
								<li>Additional credits can be purchased separately</li>
							</ul>
						</SubSection>
					</Section>

					<Section>
						<h2>3. Payment Terms</h2>
						<ul>
							<li>All prices are in LKR (Sri Lankan Rupees)</li>
							<li>Payments must be made before service activation</li>
							<li>Refunds are subject to our refund policy</li>
							<li>Late payments may result in service suspension</li>
						</ul>
					</Section>

					<Section>
						<h2>4. Intellectual Property</h2>
						<SubSection>
							<h3>4.1 Copyright</h3>
							<p>
								All photographs taken by Le Petit Photography are protected by
								copyright law. Clients receive personal usage rights as
								specified in their subscription plan.
							</p>
						</SubSection>

						<SubSection>
							<h3>4.2 Usage Rights</h3>
							<ul>
								<li>Personal, non-commercial use is permitted</li>
								<li>Commercial use requires written permission</li>
								<li>Social media sharing must credit the photographer</li>
								<li>Editing or modifying photos is not permitted</li>
							</ul>
						</SubSection>
					</Section>

					<Section>
						<h2>5. Cancellation and Refunds</h2>
						<ul>
							<li>
								Cancellations must be made 48 hours before scheduled sessions
							</li>
							<li>
								Subscription cancellations take effect at the end of the billing
								cycle
							</li>
							<li>Refunds are processed within 7-14 business days</li>
							<li>Unused credits are not refundable</li>
						</ul>
					</Section>

					<Section>
						<h2>6. Liability</h2>
						<p>
							Le Petit Photography is not liable for any circumstances beyond
							our control that may affect the quality or delivery of services.
						</p>
					</Section>

					<Section>
						<h2>7. Privacy and Data Protection</h2>
						<p>
							Your use of our services is also governed by our Privacy Policy.
							Please review our Privacy Policy to understand how we collect and
							use your information.
						</p>
					</Section>

					<Section>
						<h2>8. Changes to Terms</h2>
						<p>
							We reserve the right to modify these terms at any time. Changes
							will be effective immediately upon posting to our website.
						</p>
					</Section>

					<Section>
						<h2>9. Contact Information</h2>
						<p>
							For questions about these Terms of Service, please contact us at:
						</p>
						<ul>
							<li>Email: lepetitbylenscraft@gmail.com</li>
							<li>Phone: +94 77 771 5439</li>
							<li>Address: Maeliya, Ja-Ela, Sri Lanka.</li>
						</ul>
					</Section>
				</PolicyContent>
			</Container>
		</PolicyWrapper>
	);
};

export default TermsOfService;
